module.exports = __webpack_public_path__ + "b9349b0190b7dd85bcd7a2cb5693d09a.svg";